import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'

import Fields from './Fields'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  readonly?: boolean
}

const GeneralBlock = ({ employee, readonly }: Props) => {
  const {
    userForm,
    generalForm,
    disableSectionSaveButtons,
    onSubmit: onSubmitGeneral,
  } = useEmployeePersonalProvider()

  const onSubmit = () => {
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: [...formGetDirtyFields(generalForm), ...formGetDirtyFields(userForm)],
      legal_entity_country: employee.legalEntity?.country,
      layout_version: 'v1',
    })
    onSubmitGeneral([FormTypes.GENERAL, FormTypes.USER])
  }

  return (
    <FormComponent onSubmit={onSubmit}>
      <Fields
        employee={employee}
        readonly={readonly}
        userForm={userForm}
        generalForm={generalForm}
        disableSectionSaveButtons={disableSectionSaveButtons}
      />
    </FormComponent>
  )
}

export default observer(GeneralBlock)
